import { CSSProperties } from 'react';

import closelinkDiamondBlackUrl from '../../../../images/closelink-diamond-black.svg';
import closelinkDiamondBlueUrl from '../../../../images/closelink-diamond-blue.svg';
import closelinkDiamondWhiteUrl from '../../../../images/closelink-diamond-white.svg';

interface CloselinkDiamondProps {
    width?: number;
    height?: number;
    color?: 'black' | 'white' | 'blue';
    style?: CSSProperties;
}

export const CloselinkDiamond = ({ color = 'blue', ...props }: CloselinkDiamondProps) => {
    const urlMap = {
        white: closelinkDiamondWhiteUrl,
        black: closelinkDiamondBlackUrl,
        blue: closelinkDiamondBlueUrl,
    } as const;

    return <img alt="Closelink" {...props} src={urlMap[color]} />;
};
